import type * as React from "react";

import { AdminPeopleLayout } from "metabase/common/components/AdminLayout/AdminPeopleLayout";

export const AdminPeopleApp = ({ children }: { children: React.ReactNode }) => {
  return (
    <AdminPeopleLayout maw="80rem">
      {children}
    </AdminPeopleLayout>
  );
};
